import LegalLinks from './LegalLinks';

/** Only link to configured, existing legal pages; never publish mock legal text. Paket 12 K12-5: list in config/legal.ts. */
export default function LoginLegalLinks() {
  return <LegalLinks className="login-legal" />;
}
